import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { ServiceFocus } from '../models/service-focus';

export const FetchServiceFocuses = createAsyncThunk(
    'serviceFocuses',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios; 

        try {
            const response = await axios.get(`/api/ServiceFocuses`);

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch service focuses at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch service focuses');
            }

            return response.data as ServiceFocus[];
        } catch (error) {
            createNotification(
                'An error occurred while fetching service focuses.',
                'error'
            );
            throw error;
        }
    }
);
